import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'camelCaseToHuman'
})
export class CamelCaseToHumanPipe implements PipeTransform {
  /**
   * Converts a camel case value to a human readable value
   * (capitalizing every first letter and adding a space between each word).
   */
  static convert(value: string): string {
    return value.replace(/([A-Z])/g, ' $1').replace(/^./, (str) => str.toUpperCase());
  }

  transform(value: any): any {
    return CamelCaseToHumanPipe.convert(value);
  }
}
